module.exports = __webpack_public_path__ + "img/mobile1.e2eda2cc.webp";